import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function Historial() {
  const navigate = useNavigate();
  const [registros, setRegistros] = useState([]);
  const [gastos, setGastos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fechaFiltro, setFechaFiltro] = useState('');

  useEffect(() => { cargarDatos(); }, [fechaFiltro]);

  async function cargarDatos() {
    setLoading(true);
    let queryVentas = supabase.from('caja_diaria').select('*').order('fecha', { ascending: false });
    let queryGastos = supabase.from('gastos_diarios').select('*').order('fecha', { ascending: false });
    if (fechaFiltro) {
      queryVentas = queryVentas.eq('fecha', fechaFiltro);
      queryGastos = queryGastos.eq('fecha', fechaFiltro);
    }
    const [{ data: ventas }, { data: gastosDia }] = await Promise.all([queryVentas, queryGastos]);
    setRegistros(ventas || []);
    setGastos(gastosDia || []);
    setLoading(false);
  }

  // Agrupar por fecha
  const fechas = [...new Set(registros.map(r => r.fecha))].sort((a,b) => b.localeCompare(a));

  function ventasPorFechaTurno(fecha, turno) {
    return registros.filter(r => r.fecha === fecha && r.turno === turno);
  }

  function totalVentas(fecha, turno) {
    return ventasPorFechaTurno(fecha, turno)
      .reduce((sum, r) => sum + (r.efectivo||0) + (r.mercadopago||0) + (r.pedidosya||0) + (r.rappi||0) + (r.otros||0), 0);
  }

  function totalGastosDia(fecha) {
    return gastos.filter(g => g.fecha === fecha).reduce((sum, g) => sum + (g.monto||0), 0);
  }

  function totalDia(fecha) {
    return totalVentas(fecha,'mediodia') + totalVentas(fecha,'noche');
  }

  const fmt = n => `$${(n||0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`;
  const fmtFecha = f => new Date(f + 'T12:00:00').toLocaleDateString('es-AR', { weekday:'long', day:'numeric', month:'long', year:'numeric' });

  return (
    <div style={{ minHeight:'100vh', background:'#F2F3F4' }}>

      {/* Header */}
      <div style={{ background:'#1B2631', padding:'16px 24px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <div>
          <h1 style={{ color:'#fff', margin:0, fontSize:20 }}>📋 Historial de Cajas</h1>
          <p style={{ color:'#aaa', margin:'2px 0 0', fontSize:12 }}>Todos los días registrados</p>
        </div>
        <button onClick={() => navigate('/dashboard')}
          style={{ background:'transparent', border:'1px solid #555', color:'#aaa', padding:'8px 16px', borderRadius:8, cursor:'pointer' }}>
          ← Volver
        </button>
      </div>

      <div style={{ maxWidth:900, margin:'0 auto', padding:24 }}>

        {/* Filtro por fecha */}
        <div style={{ background:'#fff', borderRadius:12, padding:16, marginBottom:20, boxShadow:'0 2px 8px rgba(0,0,0,0.06)', display:'flex', gap:12, alignItems:'center' }}>
          <label style={{ fontSize:13, fontWeight:'bold', color:'#555' }}>🔍 Filtrar por fecha:</label>
          <input type="date" value={fechaFiltro} onChange={e => setFechaFiltro(e.target.value)}
            style={{ padding:'8px 12px', border:'1px solid #ddd', borderRadius:8, fontSize:14 }} />
          {fechaFiltro && (
            <button onClick={() => setFechaFiltro('')}
              style={{ padding:'8px 14px', background:'#eee', border:'none', borderRadius:8, cursor:'pointer', fontSize:13 }}>
              ✕ Limpiar
            </button>
          )}
        </div>

        {loading ? (
          <div style={{ textAlign:'center', padding:40, color:'#888' }}>Cargando...</div>
        ) : fechas.length === 0 ? (
          <div style={{ textAlign:'center', padding:40, color:'#888', background:'#fff', borderRadius:12 }}>
            No hay registros para mostrar
          </div>
        ) : (
          fechas.map(fecha => (
            <div key={fecha} style={{ background:'#fff', borderRadius:12, marginBottom:16, boxShadow:'0 2px 8px rgba(0,0,0,0.06)', overflow:'hidden' }}>

              {/* Header fecha */}
              <div style={{ background:'#1B2631', padding:'12px 20px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <span style={{ color:'#fff', fontWeight:'bold', fontSize:14, textTransform:'capitalize' }}>
                  📅 {fmtFecha(fecha)}
                </span>
                <span style={{ color:'#E67E22', fontWeight:'bold', fontSize:15 }}>
                  {fmt(totalDia(fecha))}
                </span>
              </div>

              <div style={{ padding:16 }}>
                {/* Turnos */}
                {['mediodia','noche'].map(turno => {
                  const ventas = ventasPorFechaTurno(fecha, turno);
                  if (ventas.length === 0) return null;
                  return (
                    <div key={turno} style={{ marginBottom:12 }}>
                      <div style={{ fontSize:13, fontWeight:'bold', color: turno==='mediodia' ? '#E67E22' : '#2471A3', marginBottom:8 }}>
                        {turno === 'mediodia' ? '🌞 Mediodía' : '🌙 Noche'} — {fmt(totalVentas(fecha, turno))}
                      </div>
                      <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
                        <thead>
                          <tr style={{ background:'#F8F9FA' }}>
                            {['Concepto','Efectivo','MercadoPago','PedidosYa','Rappi','Otros','Total'].map(h => (
                              <th key={h} style={{ padding:'6px 8px', textAlign:'center', color:'#555', fontWeight:'bold', borderBottom:'1px solid #eee' }}>{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {ventas.map((v, i) => {
                            const total = (v.efectivo||0)+(v.mercadopago||0)+(v.pedidosya||0)+(v.rappi||0)+(v.otros||0);
                            return (
                              <tr key={i} style={{ background: i%2===0 ? '#fff' : '#F8F9FA' }}>
                                <td style={{ padding:'6px 8px', fontWeight:'bold', color:'#1B2631' }}>{v.concepto}</td>
                                {[v.efectivo,v.mercadopago,v.pedidosya,v.rappi,v.otros].map((val,j) => (
                                  <td key={j} style={{ padding:'6px 8px', textAlign:'right', color: val>0 ? '#27AE60' : '#ccc' }}>{fmt(val||0)}</td>
                                ))}
                                <td style={{ padding:'6px 8px', textAlign:'right', fontWeight:'bold', color:'#27AE60' }}>{fmt(total)}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  );
                })}

                {/* Gastos del día */}
                {gastos.filter(g => g.fecha === fecha).length > 0 && (
                  <div style={{ marginTop:12, paddingTop:12, borderTop:'1px solid #eee' }}>
                    <div style={{ fontSize:13, fontWeight:'bold', color:'#C0392B', marginBottom:8 }}>
                      💸 Gastos — {fmt(totalGastosDia(fecha))}
                    </div>
                    {gastos.filter(g => g.fecha === fecha).map((g, i) => (
                      <div key={i} style={{ display:'flex', justifyContent:'space-between', fontSize:12, padding:'4px 0', borderBottom:'1px solid #f5f5f5' }}>
                        <span style={{ color:'#555' }}>{g.descripcion} <span style={{ color:'#aaa' }}>({g.categoria})</span></span>
                        <span style={{ color:'#C0392B', fontWeight:'bold' }}>{fmt(g.monto)}</span>
                      </div>
                    ))}
                  </div>
                )}

                {/* Balance del día */}
                <div style={{ marginTop:12, paddingTop:12, borderTop:'2px solid #eee', display:'flex', gap:12, justifyContent:'flex-end' }}>
                  {[
                    { label:'Ingresos', valor: totalDia(fecha), color:'#27AE60' },
                    { label:'Gastos',   valor: totalGastosDia(fecha), color:'#C0392B' },
                    { label:'Balance',  valor: totalDia(fecha) - totalGastosDia(fecha), color:'#1B2631' },
                  ].map((item,i) => (
                    <div key={i} style={{ textAlign:'center', padding:'8px 16px', background:'#F8F9FA', borderRadius:8 }}>
                      <div style={{ fontSize:11, color:'#888' }}>{item.label}</div>
                      <div style={{ fontSize:14, fontWeight:'bold', color:item.color }}>{fmt(item.valor)}</div>
                    </div>
                  ))}
                </div>

              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}